import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import BrButton from '@components/BrButton';
import BrIcons from '@components/BrIcons';
import BrText from '@components/BrText';
import ColorStyles from '@components/ColorStyles';
import './brSplitDropdownMenu.scss';

/* eslint-disable react/no-array-index-key */
export default class BrSplitDropdownMenu extends PureComponent {
  static propTypes = {
    btnColorStyle: PropTypes.oneOf(Object.values(ColorStyles)),
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isReturnWholeItem: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.element,
        isHeader: PropTypes.bool,
        title: PropTypes.string,
        value: PropTypes.any,
        dom: PropTypes.node,
      }),
    ),
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.any,
    title: PropTypes.any,
    useFirstAsDefault: PropTypes.bool, // (item.value || item) => {}
    useDownCaretV2: PropTypes.bool,
  };

  static defaultProps = {
    items: [],
    btnColorStyle: ColorStyles.GRAY,
    useFirstAsDefault: false,
    isReturnWholeItem: false,
    isDisabled: false,
    useDownCaretV2: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      selectedItem: this.getSelectedItem(props),
    }; // may use initial props
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selected } = nextProps;
    if (selected !== this.props.selected) {
      this.setState({ selectedItem: this.getSelectedItem(nextProps) });
    }
  }

  getSelectedItem = (props) => {
    const { selected, items, useFirstAsDefault } = props;
    let selectedItem = selected || '';
    // allows passing item values for matching on selected item
    if (typeof selected === 'number' || typeof selected === 'string' || typeof selected === 'boolean') {
      selectedItem = items.find((item) => item.value === selected);
    }
    // if no match, set to first item from the list if so desired
    if (!selectedItem && useFirstAsDefault && items.length) {
      selectedItem = items[0];
    }
    return selectedItem;
  };

  handleSelectItem = (item) => {
    const { onSelect, isReturnWholeItem } = this.props;
    if (onSelect) {
      onSelect(item.value !== undefined && !isReturnWholeItem ? item.value : item);
    }
    this.setState({ isActive: false });
  };

  handleBlur = () => {
    this.setState({ isActive: false });
  };

  handleDropdownClick = () => {
    if (!this.props.isDisabled) {
      this.setState({ isActive: !this.state.isActive });
    }
  };

  renderDisplayTitle = (item) => (
    <div className={cn('item-title', { disabled: this.props.isDisabled })}>
      {item.icon}
      <div>
        <BrText>{item.title || item.value}</BrText>
      </div>
      {item.dom}
    </div>
  );

  render() {
    const { title, items, className, isDisabled, btnColorStyle, onClick, useDownCaretV2 } = this.props;

    const { isActive, selectedItem } = this.state;

    const brSplitDropdownMenuClassName = cn('br-split-dropdown-menu', className, btnColorStyle, {
      active: isActive,
      disabled: isDisabled,
    });

    const brDropdownCaretClassName = cn('br-dropdown-caret', btnColorStyle);

    const btnTitle = title || (selectedItem && this.renderDisplayTitle(selectedItem)) || '';
    const handleOnButtonClick = isDisabled ? null : onClick;
    const handleOnDropdownCaretClick = isDisabled ? null : this.handleDropdownClick;

    return (
      <div
        className={brSplitDropdownMenuClassName}
        tabIndex="0"
        onBlur={this.handleBlur}
        data-id="br-split-dropdown-menu"
      >
        <BrButton title={btnTitle} onClick={handleOnButtonClick} isSubComp colorStyle={btnColorStyle} />
        {items && items.length > 0 && (
          <div className={brDropdownCaretClassName} onClick={handleOnDropdownCaretClick}>
            <i className="prefix-icon">
              {useDownCaretV2 ? (
                <BrIcons.DownCarrotV2 colorStyle={btnColorStyle} isSubComp />
              ) : (
                <BrIcons.DownCaret colorStyle={btnColorStyle} isSubComp />
              )}
            </i>
          </div>
        )}
        <div className="dropdown-item-list">
          {items.map((item, idx) => (
            <div
              key={idx}
              className={cn('dropdown-item', { 'is-selected': item === selectedItem })}
              onClick={() => this.handleSelectItem(item)}
            >
              {this.renderDisplayTitle(item)}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
